/**
 * Ryan O'Dowd
 * 2024-07-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts}) => {
  return {
    translationText: {
      textDecorationLine: 'underline',
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
